module.exports = __webpack_public_path__ + "static/media/13 Illegal Grip.5808f2e9.jpg";